module.exports = __webpack_public_path__ + "img/icon-success.f839ccf9.svg";